import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BetaModeBanner from '../beta/BetaModeBanner';
import SeoHighlightsPanel from '../beta/SeoHighlightsPanel';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <BetaModeBanner />
      <Header />
      <SeoHighlightsPanel />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
